import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Commercial } from "../../../types";
import { getTagManagerService } from "../../../services/tag-manager.service";
import { moduleSettings } from "../../../stores/module-settings.store";
import { CommercialsEventItem } from "../event/commercials-event-item";
import { CommercialsOfferItem } from "../offer/commercials-offer-item";
import { Title } from "../../title/title";
import { MenuOfferWrapper } from "../menu-offer-wrapper";
import CommercialsService from "../../../services/commercials.service";
import ReactPixel from "react-facebook-pixel";
import { ErrorMessage } from "../../errors/message-error-view";
import { ErrorType } from "../../../services/api-errors/error-types";
import { pendingBookingStore } from "../../../stores/pending-booking.store";
import { CommercialMenus } from "../commercial-menus";
interface IDisplay {
  setChildLoading: (state: boolean) => void;
}

const Display = (props: IDisplay) => {
  const { t } = useTranslation();
  const commercialsService = CommercialsService;
  const { hasEvents, hasMenus, hasOffers } =
    commercialsService.availableCommercials();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const setErrorMessageFromChild = (message: string) => setErrorMsg(message);
  const menuSelectionRequested = pendingBookingStore.menuSelectionRequested;

  const events = hasEvents
    ? commercialsService.events.map((ev: Commercial) => {
        return <CommercialsEventItem key={ev.id} commercial={ev} />;
      })
    : [];

  const offers = hasOffers
    ? commercialsService.offers.map((offer: Commercial) => {
        const selectedOffer = { ...offer, isSelected: false };
        return (
          <CommercialsOfferItem
            key={selectedOffer.id}
            offer={selectedOffer}
            setChildLoading={props.setChildLoading}
            setErrorMessage={setErrorMessageFromChild}
          />
        );
      })
    : [];

  useEffect(() => {
    const restaurantId = moduleSettings.getRestaurantId();
    getTagManagerService(restaurantId).pushTags("commercials");
    ReactPixel.pageView();
  }, []);

  const titleProps = menuSelectionRequested
    ? {
        mandatory: menuSelectionRequested,
        extraText: t("instabook.menus.selection_requested"),
        text: t("instabook.menus.title"),
        type: "tab",
      }
    : {
        text: t("instabook.menus.title"),
        mandatory: menuSelectionRequested,
        type: "tab",
      };

  const restaurantId = moduleSettings.getRestaurantId();
  getTagManagerService(restaurantId).pushTags("commercials");
  return (
    <div data-test="commercials-display">
      {errorMsg && <ErrorMessage error={errorMsg} status={ErrorType.error} />}
      {hasEvents && (
        <div data-test="commercials-events">
          <Title text={t("instabook.events.title")} />
          {events}
        </div>
      )}
      {hasMenus && (
        <CommercialMenus
          title={titleProps}
          setChildLoading={props.setChildLoading}
        />
      )}
      {hasOffers && (
        <div data-test="commercials-offers">
          <Title text={t("instabook.offers.title")} />
          <MenuOfferWrapper>{offers}</MenuOfferWrapper>
        </div>
      )}
    </div>
  );
};
export const CommercialsDisplay = memo(Display);
